import { CBCore, CBLanguageService } from "cbcore-ts"
import { IS, UICore, UIRoute } from "uicore-ts"
import { RHCore } from "./Core/RHCore"
import { RHUsageEventRuntime } from "./Core/RHUsageEventRuntime"
import { RHWorkflowRecordingRuntime } from "./Core/RHWorkflowRecordingRuntime"
import { EditorViewController } from "./EditorViewController"
import { LanguageService } from "./LanguageService"
import { RootViewController } from "./RootViewController"
import { RHTestRuntime } from "./Testing/RHTestRuntime"
import { RHWorkflowRecordingPanel } from "./Testing/RHWorkflowRecordingPanel"
import { RHDetachedLoadingView } from "./Core/RHDetachedLoadingView"


function removeLoadingView() {
    
    const loadingViewElement = document.getElementById("LoadingView")
    const rootViewElement = document.getElementById("RootView")
    
    if (rootViewElement && loadingViewElement) {
        RHDetachedLoadingView.hold(loadingViewElement)
        rootViewElement.removeChild(loadingViewElement)
    }
    
}

try {
    
    // @ts-ignore
    // noinspection JSUnusedAssignment
    var CBCoreInitializerObject = CBCoreInitializerObject ?? {}
    CBCoreInitializerObject.defaultLanguageKey = "est"
    
    CBCore.registerSharedInstance(new RHCore())
    CBLanguageService.currentClassObject = LanguageService
    LanguageService.useStoredLanguageValues({})
    UICore.languageService = LanguageService
    RHUsageEventRuntime.install()
    RHUsageEventRuntime.installInternalUsageSink()
    RHWorkflowRecordingRuntime.install()
    
    const editorControllerComponent = UIRoute.currentRoute.componentWithName(EditorViewController.routeComponentName)
    
    if (IS(editorControllerComponent)) {
        
        UICore.main = new UICore("RootView", EditorViewController)
        
        // @ts-ignore
        window.editorViewController = UICore.main.rootViewController
        
    }
    else {
        
        UICore.main = new UICore("RootView", RootViewController, 16)
        
    }
    
    RHTestRuntime.install()
    RHWorkflowRecordingPanel.install()

    
    removeLoadingView()
    
} catch (exception) {
    
    console.log(exception)
    
    //window.location = "/unsupported";
    
}
